import React from 'react';
import PointReferralIssueListSearchBox from '../PointReferralIssueListSearchBox';
import PointReferralIssueList from '../PointReferralIssueList';

const PointReferralIssueListWrap = (props) => {
  const { setData, getList, pointReferralIssueList } = props;

  return (
    <div className="point-referral-issue-list-wrap">
      {/*레퍼럴 발급 현황 검색 박스*/}
      <PointReferralIssueListSearchBox
        setData={(data) =>
          setData({
            path: ['pointReferralIssueList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={pointReferralIssueList.searchData}
        getList={getList}
      />

      {/*레퍼럴 발급 현황 리스트*/}
      <PointReferralIssueList
        pointReferralIssueList={pointReferralIssueList.list}
        sortOption={pointReferralIssueList.sortOption}
        pagination={pointReferralIssueList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default PointReferralIssueListWrap;
